import styled from "styled-components"
import { devices } from "../../../../themes/theme"

const ValueAndUnit = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 0.5rem;
  row-gap: clamp(0rem, -0.2rem + 1vw, 1rem);
  margin-block-start: 0.25rem;
  width: fit-content;
`

const BaseRow = styled.div<{
  $coloredBackground?: boolean
  $header?: boolean
}>`
  background-color: ${(props) =>
    props.$coloredBackground
      ? props.theme.colors.bodyBackground
      : props.theme.colors.boxBackground};
  padding: 1rem;
  @media (${devices.laptop}) {
    padding: 2rem;
    grid-template-columns: 2fr 2rem 1fr 2rem 15rem;
  }
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 140%;
`
const Row = styled(BaseRow)`
  display: grid;
  @media (${devices.laptop}) {
    padding: 2rem;
  }
`

const HeaderRow = styled(BaseRow)`
  display: none;
  @media (${devices.laptop}) {
    border-radius: 8px;
    display: grid;
    padding-inline: 2rem;
    padding-block-start: 2rem;
    padding-block-end: 0;
  }
`

const ResultRow = styled(BaseRow)`
  display: grid;
  row-gap: 0.5rem;
  justify-content: center;
  justify-items: center;

  margin-block: 2rem 1rem;

  @media (${devices.laptop}) {
    justify-content: unset;
    justify-items: unset;
  }
`

const Cell = styled.div`
  display: flex;
  @media (${devices.laptop}) {
    justify-content: flex-end;
  }
`

const HeaderCell = styled.div`
  display: flex;
`
const Label = styled.div`
  font-size: 0.875rem;
  @media (${devices.laptop}) {
    font-size: 0.875rem;
  }
`
const Value = styled.span<{
  $lg?: boolean
}>`
  display: block;
  color: ${(props) => props.theme.colors.primary};
  font-family: ${(props) => props.theme.fontFamilyEN};
  font-size: ${(props) => (props.$lg ? `1.8rem` : `1.5rem`)};
  letter-spacing: -0.011em;
  @media (${devices.laptop}) {
    font-size: 2rem;
  }
`

const Unit = styled.span`
  display: block;
  font-size: 0.8rem;
  text-wrap: nowrap;
  margin-left: auto;
  @media (${devices.laptop}) {
    font-size: 1rem;
  }
`

const RowHeader = styled.div`
  font-size: 1rem;
  font-size: 0.75rem;
  font-weight: 400;
  &:not(:first-child) {
    margin-block-start: 1rem;
  }
  @media (${devices.laptop}) {
    display: none;
  }
`

const Spacer = styled.div`
  display: none;
  @media (${devices.laptop}) {
    display: block;
  }
`

export {
  Cell,
  HeaderCell,
  HeaderRow,
  Label,
  ResultRow,
  Row,
  RowHeader,
  Spacer,
  Unit,
  Value,
  ValueAndUnit,
}
